// call api
// export const API_URL = "http://localhost:3001"
export const API_URL = "https://5f83e2936b97440016f4eb8f.mockapi.io/"


// Get poducts
export const GET_PRODUCT_DETAIL_SUCCESS = "GET_PRODUCT_DETAIL_SUCCESS"
export const GET_ALL_PRODUCT_SUCCESS = "GET_ALL_PRODUCT_SUCCESS"
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS"
export const FILTER_VALUE = "FILTER_VALUE"
export const SORT_PRODUCTS = "SORT_PRODUCTS"

// cart
export const ADD_TO_CART = "ADD_TO_CART"
export const UPDATE_ITEM_CART = "UPDATE_ITEM_CART"
export const DELETE_ITEM_CART = "DELETE_ITEM_CART"
export const CART_COMPLETE = "CART_COMPLETE"

// modal

export const SHOW_MODAL = "SHOW_MODAL"
export const HIDE_MODAL = "HIDE_MODAL"

// order
export const ADD_ORDER = 'ADD_ORDER';
export const SET_ORDER_DETAIL = 'SET_ORDER_DETAIL';
export const GET_ALL_ORDER = "GET_ALL_ORDER"

// comments 
export const SEND_COMMENT = "SEND_COMMENT"
// cmt product
export const SEND_COMMENT_PRODUCT = "SEND_COMMENT_PRODUCT"
export const GET_ALL_COMMENT_PRODUCT = "GET_ALL_COMMENT_PRODUCT"

// blogs
export const GET_ALL_BLOG = "GET_ALL_BLOG"
export const GET_BLOG_DETAIL = "GET_BLOG_DETAIL"
export const CREATE_BLOG = "CREATE_BLOG"

// account
export const SET_CURRENT_USER_REQUEST = "SET_CURRENT_USER_REQUEST"
export const SET_CURRENT_USER_SUCCESS = "SET_CURRENT_USER_SUCCESS"
export const SET_CURRENT_USER_FAILURE = "SET_CURRENT_USER_FAILURE"
export const SET_LOGOUT = "SET_LOGOUT"